module.exports = __webpack_public_path__ + "static/media/479JamesPBrawleyDrNW_2018-06-12_88.c8a2431d.jpg";